import PropTypes from 'prop-types'
import React from 'react'

import Text from 'components/common/Text'

import { Notification } from './styles'

const GeneralNotifications = props => {
    const { icon, title, subtitle, toastProps } = props
    return (
        <Notification.Area>
            <Notification.Icon>
                <img {...icon} />
            </Notification.Icon>
            <Notification.Content>
                <Text level="3">{title}</Text>
                <Text level="2" bold={false} color="#ffffffdb">
                    {subtitle}
                </Text>
            </Notification.Content>
            <Notification.Cta>
                <div onClick={toastProps.closeToast}>
                    <img src="assets/revamp/cross.svg" alt="cross" />
                </div>
            </Notification.Cta>
        </Notification.Area>
    )
}

GeneralNotifications.propTypes = {
    icon: PropTypes.object,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onClose: PropTypes.func,
}

GeneralNotifications.defaultProps = {
    icon: {},
    title: '',
    subtitle: '',
    onClose: () => {},
}

export default GeneralNotifications
